import React from 'react';

import CalendarDateHeader from './CalendarDateHeader';
import DayNameTypography from './DayNameTypography';

// Custom header component for week view
export const CustomHeader = ({ date }: { date: Date }) => {
  return <CalendarDateHeader date={date} sx={{ pb: 0.75 }} />;
};

// Custom time gutter header for day view
export const CustomTimeGutterHeader = ({ currentDate }: { currentDate: Date }) => {
  return <CalendarDateHeader date={currentDate} />;
};

// Custom month header component - shows styled day names
export const CustomMonthHeader = ({ label }: { label: string }) => (
  <DayNameTypography sx={{ p: 1 }}>{label}</DayNameTypography>
);